module.exports = __webpack_public_path__ + "img/mobile-app2.85c906f5.png";